import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useHortalandEnabled() {
  const { data, isLoading } = useQuery({
    queryKey: ['hortaland-enabled'],
    queryFn: async () => {
      const { data } = await supabase
        .from('platform_settings' as any)
        .select('value')
        .eq('key', 'hortaland_enabled')
        .maybeSingle();
      return (data as any)?.value?.enabled ?? false;
    },
    staleTime: 1000 * 5,
    refetchOnWindowFocus: true,
    refetchInterval: 1000 * 10,
  });

  return { enabled: data ?? false, loading: isLoading };
}
